define('popupNew', function () {
    require("jqueryUI");
    var Handlebars = require("handlebars");
    var popupTemplate = Handlebars.compile(require("text-loader!./templates/popup.html"));
    var i18n = require('l10n');

    var defaultParams = {
        'type'      : "alert",
        'saveBtn'   : {
             'el': null,
             'text': null
         },
        'deleteBtn' : {
            'el': null,
            'text': null
        },
        'cancelBtn' : {
            'el': null,
            'text': null
        },
        'copyBtn'   : {
             'el': null,
             'text': null
         },
        'link'      : null,
        'title'     : null,
        'content'   : null
    }

    var Url = null;
    var deleteBtn = null;
    var cancelBtn = null;
    var copyBtn = null;
    var saveBtn = null;
    var showProgressBar = null;
    var hideProgressBar = null;

    var availableTemplates = {
        "copy_link": popupTemplate,
        "confirm_delete": popupTemplate,
        "alert": popupTemplate
    };

    var element = $("<div id='popup_div'></div>");
    var show = function(title, content, templateName, options ) {

        var self = this;
        if ( $("#popup_div") )
            $("#popup_div").remove();

        var template = availableTemplates[templateName];
        if (template) {
            var templateParams = {
                'type'      : templateName,
                'saveBtn'   : options._buttons.saveBtn   ? options._buttons.saveBtn.text   : null,
                'deleteBtn' : options._buttons.deleteBtn ? options._buttons.deleteBtn.text : null,
                'cancelBtn' : options._buttons.cancelBtn ? options._buttons.cancelBtn.text : null,
                'copyBtn'   : options._buttons.copyBtn   ? options._buttons.copyBtn.text   : null,
                'link'      : options._url,
                'title'     : title,
                'content'   : content
            }

            templateParams = $.extend(defaultParams, templateParams);

            element.html(template(templateParams));
            $("body").append(element);

            showProgressBar = options._showProgressBar;
            hideProgressBar = options._hideProgressBar;
            Url = options._url;
            deleteBtn = options._buttons.deleteBtn ? options._buttons.deleteBtn.el : null;
            cancelBtn = options._buttons.cancelBtn ? options._buttons.cancelBtn.el : null;
            copyBtn = options._buttons.copyBtn     ? options._buttons.copyBtn.el   : null;
            saveBtn = options._buttons.saveBtn     ? options._buttons.saveBtn.el   : null;

            bind_events();
        }
    };

    var bind_events = function() {
        var self = this;


        $('.popup-close').off("click").on("click", function() {
            if ( $("#popup_div") )
                $("#popup_div").remove();
        });

        /*
           use it as a check to ensure that if moving the mouse too quickly (and having it outside
           of the DRAGGED field), it will not change the cursor
        */
        var isMouseDown = false;
        /*    add 'dragging' class on drag and remove it afterwards    */
        $(".popup-title").off("mousedown mouseup").on("mousedown mouseup mouseout", function(e) {
            var $el = $("#popup_div .popup");
            var $el = $("#popup_div .popup");

            switch(e.type) {
                case "mousedown":
                    isMouseDown = true;
                    $el.removeClass("grabbing").addClass("grabbing");

                    break;
                case "mouseup":
                    isMouseDown = false;
                    $el.removeClass("grabbing");

                    break;
                case "mouseout":
                    if(isMouseDown)
                        break;

                    isMouseDown = false;
                    $el.removeClass("grabbing");
                    break;
                default:

            }
        });

        /*    Bind Drag Event    */
        $("#popup_div .popup").draggable({
            start: function(event, ui) {
                $($(this).find(".popup-title")[0]).addClass('noclick');
            },
            handle: ".popup-title", // Disable dragging while not on header,
            containment: "window" // Constrains dragging to within the bounds of the specified element or region. ("parent", "document", "window")
        });

        /*   Open/close the content of the alert   */
        $('#popup_div .popup .popup-title').off("click").on("click", function() {
            if ($(this).hasClass('noclick')) {
                $(this).removeClass('noclick');
            }
            else {
                var $content =  $(element.parent().find(".popup-content.alert")[0]);
                $content.toggle();
            }
        });

        if(copyBtn)
            $(copyBtn).off("click").on("click", function() {
                var copyText =  element.find(".popup-content input")[0];
                copyText.select();
                document.execCommand("copy");
                $(this).notify(i18n.t("general.copy_success"), { position:"top right", className: "success" });
            });

        if(deleteBtn)
            $(deleteBtn).off("click").on("click", function() {
                showProgressBar();
                url = Url;
                $.ajaxDefaultQ({
                    url: url,
                    type: "DELETE",
                    contentType: "application/json;charset=UTF-8"
                }).done(function(response, status, xhr){
                    self.totalCalls = self.totalCalls - 1;
                    if(self.totalCalls == 0 &&self.callback && self.callback.success)
                        self.callback.success(response);

                    if(deleteBtn)
                        deleteBtn.hide();
                    hideProgressBar();
                })
                .fail(function(response) {
                    self.totalCalls = self.totalCalls - 1;
                    if(self.totalCalls == 0 &&self.callback && self.callback.success)
                        self.callback.success(response);

                    hideProgressBar();
                });

                if ( $("#popup_div") )
                    $("#popup_div").remove();
            });

        if(cancelBtn)
            $(cancelBtn).off("click").on("click", function() {
                if ( $("#popup_div") )
                    $("#popup_div").remove();
            });
    };


    return {
        "show": show
    };
});